<!-- 
 * @description: 註冊模块
 * @fileName: template.vue 
 * @author: 薛微微 
 * @date: 2023-06-21 17:23:17
!-->
<template>
  <div class="register" :class="this.$Base.checkSysteam() == 'MOBILE' ? 'mregister' : 'register'">
    <Region v-if="showRegion" @confirm="onRegionConfirm" />
    <!-- input -->
    <div class="inputBox">
      <div class="input-style">
        <input type="text" :placeholder="$t('message.input_account')" class="user" v-model.trim="username"
          @click="focusEnd('regUsername')" id="regUsername" />
      </div>
      <div class="input-style">
        <input type="password" :placeholder="$t('message.input_password')" class="pass" v-model.trim="password"
          @click="focusEnd('regPassword')" id="regPassword" />
      </div>
      <div class="input-style">
        <input type="password" :placeholder="$t('message.input_password_again')" class="pass"
          v-model.trim="confirmPassword" @click="focusEnd('confirmPassword')" id="confirmPassword" />
      </div>
      <div class="input-style" v-if="isCodeShow">
        <input type="text" :placeholder="$t('message.enter_code')" class="code" v-model.trim="code"
          @click="focusEnd('regCode')" id="regCode" />
        <div class="random" @click="getImage">
          <img :src="imgurl" />
        </div>
      </div>
    </div>
    <!-- 注册按钮 -->
    <div class="sendBtn" :class="username &&
      password &&
      confirmPassword &&
      (isCodeShow == false || (isCodeShow && code))
      ? 'active'
      : ''
      " @click="reg() && isReg">
      {{ $t("message.navigator_signIn") }}
    </div>
  </div>
</template>

<script>
import Region from "../region/index.vue";
import { RSSign } from "../../utils/sign.js";
export default {
  name: "RastarRegister",
  props: [
    "appId",
    "pId",
    "mdId",
    "ukey",
    "msgVal",
    "initialization",
    "system",
    "getCodeShow",
  ],
  components: { Region },
  data() {
    return {
      username: "",
      password: "",
      showRegion: !localStorage.getItem('selected_region'),
      region: localStorage.getItem('selected_region') || "EURO",
      confirmPassword: "",
      code: "",
      isLiang: false,
      isCodeShow: false,
      token: "",
      imgurl: "",
      captchaCode: "",
      isReg: "",
    };
  },
  watch: {
    initialization: {
      handler(val, oldV) {
        console.log("initialization", val, oldV);
        if (val) {
          this.getImage();
        }
      },
      deep: true,
    },
  },
  methods: {
    // 确认大区选择
    onRegionConfirm(v) {
      this.region = v;
      this.showRegion = false;
    },
    sendCodeShow() {
      this.getCodeShow(false);
    },
    /*
     *@description: 兼容ios input光标位置不对
     *@author: 薛微微
     *@date: 2023-06-21 11:24:16
     */
    focusEnd(id) {
      let inpEl = document.getElementById(id);
      inpEl.focus();
      let length = inpEl.value.length;
      if (document.selection) {
        let range = inpEl.createTextRange();
        range.moveStart("character", length);
        range.collapse();
        range.select();
      } else if (
        typeof inpEl.selectionStart === "number" &&
        typeof inpEl.selectionEnd === "number"
      ) {
        // selectionStart和selectionEnd两个属性是当前选中文本起始位置的索引
        inpEl.selectionStart = inpEl.selectionEnd = length;
      }
    },
    /*
     *@description: 触发埋点上报
     *@author: 薛微微
     *@date: 2023-06-21 17:06:16
     */
    webDotChildReg(nodeVal) {
      this.$Report.webDotFather(this.pId, this.appId, this.ukey, nodeVal);
    },
    /*
     *@description: 接口错误上报
     *@author: 薛微微
     *@date: 2023-06-21 17:06:40
     */
    webErrorlogChild(errorMsg, action) {
      this.$Report.webErrorlogFather(
        this.pId,
        this.appId,
        this.ukey,
        errorMsg,
        action
      );
    },
    /*
     *@description: 获取图形验证码
     *@author: 薛微微
     *@date: 2023-06-19 17:03:23
     */
    getImage() {
      let _this = this;
      this.$generalMethod
        .captcha(this.pId, this.appId, "register")
        .then((res) => {
          if (res.code == 200) {
            let data = res.data;
            _this.isCodeShow = data.flag == 1 ? true : false;
            _this.imgurl = data.captcha;
            _this.captchaCode = data.captcha_code;
          } else {
            _this.$toast(res.msg.replace(/\[.*?\]/g, ""));
          }
        });
    },
    /*
     *@description: 请求注册
     *@author: 薛微微
     *@date: 2023-06-19 16:59:31
     */
    regSubmit(token) {
      let _this = this;
      let uinfoData = {
        uname: _this.username,
        pwd: _this.password,
      };
      let data = {
        ts: new Date().getTime(),
        cch_id: _this.pId,
        app_id: _this.appId,
        md_id: _this.mdId,
        euser_region: _this.region,
        sys_language: this.$Storage.localStorageGet("lang"),
        token: token,
        time_zone: this.$Base.timeZone(),
        device_id: this.$Storage.localStorageGet("deviceIdUa"),
        nonce: this.$Base.nonce(12),
        sdk_ver: this.$Base.sdkVer(),
        version: this.$Base.getVersion(),
        captcha_code: "" || _this.code,
      };
      data.uinfo = this.$Ciphertext.AESkey(uinfoData);
      data.sign = RSSign(data, data.app_id);
      let api = JSON.parse(this.$Storage.localStorageGet("api"));
      this.$SyModel
        .reg(api.user.general_reg, data)
        .then((res) => {
          if (res.code == 200) {
            _this.$emit("loginSuccess", res);
            // _this.emailBindShow = res.data.email_bind_show;
            // this.$Storage.localStorageSet("show", _this.emailBindShow);
            this.$Storage.localStorageSet("apiUname", _this.username);
            this.$Storage.localStorageSet("apiPwd", _this.password);
            // this.$Storage.localStorageSet("_XH_U_WEBSDK", res.data.uinfo);
            // this.$Storage.localStorageSet("serviceUinfo", res.data.kf_uinfo);
            // this.$Storage.localStorageSet(
            //   "access_token",
            //   res.data.access_token
            // );
            // // 标识是新注册进来的
            // this.$Storage.localStorageSet("regId", 1);
            // // 注册成功埋点
            // if (this.system === "pc") {
            //   this.webDotChildReg("signup_pcldy_success");
            // } else {
            //   this.webDotChildReg("signup_moldy_success");
            // }
            // // 成功跳转
            // window.location.href = `/web?ukey=${_this.ukey}&appid=${_this.appId}&pid=${_this.pId}&md_id=${_this.mdId}`;
          } else {
            let errorMsg = res.msg.replace(/\[.*?\]/g, "");
            _this.$toast(errorMsg);
            _this.getImage();
          }
        })
        .catch((err) => {
          this.webErrorlogChild(err.msg, "注册接口");
        });
    },
    /*
     *@description: 注册前置判断方法
     *@author: 薛微微
     *@date: 2023-06-19 16:59:04
     */
    reg() {
      let isCache = this.$Storage.localStorageGet("deviceIdUa");
      if (!isCache) {
        // 不存在就强制刷新页面 deviceIdUa isCache不存在
        location.reload();
      } else {
        let _this = this;
        if (
          !(
            _this.username &&
            _this.password &&
            _this.confirmPassword &&
            (_this.isCodeShow == false || (_this.isCodeShow && _this.code))
          )
        )
          return;
        if (this.system === "PC") {
          this.webDotChildReg("click_pcldy_signup");
        } else {
          this.webDotChildReg("click_moldy_signup");
        }
        //用户名正则，4到15位（字母，数字，下划线，减号）
        var uPattern = /^[a-zA-Z0-9_-]{4,12}$/;
        if (!uPattern.test(this.username)) {
          this.$toast(this.$t("message.emailTips5"));
          return;
        }
        //密码强度正则，最少6位
        var pPattern = /^.*(?=.{6,20}).*$/;
        if (!pPattern.test(this.password)) {
          this.$toast(this.$t("message.emailTips6"));
          return;
        }
        var reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
        if (reg.test(this.password) || reg.test(this.confirmPassword)) {
          this.$toast(this.$t("message.emailTips1"));
          return;
        }
        // 两个密码做对比是不是一样
        if (_this.password !== _this.confirmPassword) {
          _this.$toast(_this.$t("message.emailTips7"));
          return;
        }
        // 验证码是否一致
        if (_this.isCodeShow == 1) {
          if (_this.captchaCode.toLowerCase() != _this.code.toLowerCase()) {
            _this.$toast(_this.$t("message.emailTips4"));
            return;
          }
        }
        this.$generalMethod
          .freezetoken(this.pId, this.appId, this.mdId)
          .then((res) => {
            if (res.code == 200) {
              _this.regSubmit(res.data);
            } else {
              _this.$toast(res.msg.replace(/\[.*?\]/g, ""));
            }
          });
      }
    },
  },
  created() {
    this.getImage();
    this.sendCodeShow();
  },
};
</script>

<style lang="scss" src="./style.scss"></style>
